const notifActionTypes = {
  SUCCESS_NOTIF: 'SUCCESS_NOTIF',
  FAILED_NOTIF: 'FAILED_NOTIF',
  GET_NOTIF_TO: 'GET_NOTIF_TO',
  SET_NOTIF_TO: 'SET_NOTIF_TO',
  GET_NOTIF_TO_DETAIL: 'GET_NOTIF_TO_DETAIL',
  SET_NOTIF_TO_DETAIL: 'SET_NOTIF_TO_DETAIL',
  SET_NOTIF_TO_DETAIL_ERROR: 'SET_NOTIF_TO_DETAIL_ERROR',
  GET_NOTIF_FROM: 'GET_NOTIF_FROM',
  SET_NOTIF_FROM: 'SET_NOTIF_FROM',
  GET_NOTIF_FROM_DETAIL: 'GET_NOTIF_FROM_DETAIL',
  SET_NOTIF_FROM_DETAIL: 'SET_NOTIF_FROM_DETAIL',
  SET_NOTIF_FROM_DETAIL_ERROR: 'SET_NOTIF_FROM_DETAIL_ERROR',
  ACCEPT_REQUEST: 'ACCEPT_REQUEST',
  DECLINE_REQUEST: 'DECLINE_REQUEST',
  DELETE_REQUEST: 'DELETE_REQUEST',
  SET_NOTIF_ACTIVITY: 'SET_NOTIF_ACTIVITY',
  SET_ACTIVITY_TIME: 'SET_ACTIVITY_TIME',
  GET_NOTIFICATION: 'GET_NOTIFICATION',
  SET_NOTIFICATION: 'SET_NOTIFICATION',
};

export default notifActionTypes;
